import SwitchRole from '../components/SwitchRole.vue';
import Details from '../components/Details.vue';
import ManageCredentials from '../components/ManageCredentials.vue';

export default [
  {
    path: '',
    redirect: 'details',
    role: ['User']
  },
  {
    path: 'details',
    component: Details,
    meta: {
      title: 'Details',
      role: ['User'],
      breadcrumb: [
        {
          path: '/home',
          title: 'Home'
        },
        {
          path: '',
          title: 'Details'
        }
      ]
    }
  },
  {
    path: 'switch-role',
    component: SwitchRole,
    meta: {
      title: 'Switch Role',
      role: ['User'],
      breadcrumb: [
        {
          path: '/home',
          title: 'Home'
        },
        {
          path: '',
          title: 'Switch Role'
        }
      ]
    }
  },
  {
    path: 'manage-credentials',
    component: ManageCredentials,
    meta: {
      title: 'Manage Credentials',
      role: ['User'],
      breadcrumb: [
        {
          path: '/home',
          title: 'Home'
        },
        {
          path: '/account/manage-credentials',
          title: 'Manage Credentials'
        }
      ]
    }
  }
];
